module.exports = __webpack_public_path__ + "img/shop-manage.de2b34b4.svg";